<template>
  <div class="history-list-wrapper">
    <a-row>
      <a-col
        :span="24"
        v-for="history in data"
        :key="history.id"
        @click="$emit('onHistoryActive', history)"
        class="history-item-wrapper"
      >
        <HistoryItem :data="history" :activeId="activeId" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import HistoryItem from "./HistoryItem/HistoryItem.vue";
export default {
  name: "HistoryList",
  components: {
    HistoryItem,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeId: null,
    };
  },
  methods: {},
  beforeMount() {},
};
</script>

<style lang="scss" scoped>
.history-list-wrapper {
  border: 1px solid #eaeaea;
  padding: 6px;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 6px;
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 32, 46, 0.62);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
  }
  .history-item-wrapper {
    border-bottom: 1px solid #eaeaea;
    border-radius: 6px;
    margin-bottom: 6px;
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
